'use_strict';

const $ = require('jquery');

let fileInput = {
  init: function(){
    $('input[type="file"][data-value-field]').on('change', function(evt){
      $(this.getAttribute('data-value-field')).val(this.files[0].name).trigger('change');
    });
  }
};

export default fileInput;
